import { CmcWebApi, IWebApiRequestBody } from '@cmctechnology/webinvest-api-client-web-trading';
import { frontendActions } from '@cmctechnology/webinvest-store-frontend';
import { Dispatch } from '@reduxjs/toolkit';
import { ACCOUNT_API_NAMES } from './apis';
import { ACCOUNT_STORE_NAME, actions, IStore } from './store';
import { AccountOptionPositionsRequest1 } from './types';

export const fetchOptionHoldings = (accountNo: string, refresh: boolean = false) => {
  return async (dispatch: Dispatch<any>, getState: () => IStore) => {
    if (!refresh && getState()[ACCOUNT_STORE_NAME].optionHoldings[accountNo]) return;

    const request: AccountOptionPositionsRequest1 & IWebApiRequestBody = {
      AccountFilter: accountNo,
      IncludeIntraday: true,
      IncludePrices: true
    };

    try {
      const response = await frontendActions.webTradingApiCall<CmcWebApi.Account.AccountOptionsPositionsModel1>(
        ACCOUNT_STORE_NAME,
        ACCOUNT_API_NAMES.AccountOptionPositionsGet1,
        request,
        dispatch,
        accountNo
      );
      dispatch(actions.optionHoldingsFetched({ accountNo, optionHoldings: response.OptionPositionsGroups[0].OptionPosition }));
    } catch {}
  };
};
